import { lazy } from "react";

const listOfMonarchComponents = {
  frinBannerLtoBricksEditable: lazy(
    () => import("@/monarch/Banner | LTO (Bricks) - Editable"),
  ),
  frinSectionProductCardsBricksEditable: lazy(
    () => import("@/monarch/Section | Product Cards (Bricks) - Editable"),
  ),
  frinHeroBauBricksEditable: lazy(
    () => import("@/monarch/Hero | BAU (Bricks) - Editable"),
  ),
  frinBannerAddressCheckWhite: lazy(
    () => import("@/monarch/Banner | Address Check | White"),
  ),
  frinBannerListExpansion: lazy(
    () => import("@/monarch/Banner | List | Expansion"),
  ),
  frinHeroAddressCheck5G: lazy(
    () => import("@/monarch/Hero | Address Check | 5G"),
  ),
  frinSectionSpeedVisualsBricksEditable: lazy(
    () => import("@/monarch/Section | Speed Visuals (Bricks) - Editable"),
  ),
  frinSectionSplitModuleBricksEditable: lazy(
    () => import("@/monarch/Section | Split Module (Bricks) - Editable"),
  ),
  frinSectionCarouselThumbExpansion: lazy(
    () => import("@/monarch/Section | Carousel | Thumb Expansion"),
  ),
  frinSectionGdtCta: lazy(() => import("@/monarch/Section | GDT | CTA")),
};

export default listOfMonarchComponents;
